const testData = {
  alborz: 10,
  ardebil: 20,
  azerbaijansharghi: 30,
  azerbaijangharbi: 40,
  bushehr: 34,
  chvab: 67,
  fars: 12,
  gilan: 1,
  golestan: 54,
  hamedan: 67,
  hormozgan: 32,
  ilam: 66,
  esfehan: 42,
  kerman: 13,
  kermanshah: 12,
  khorasanshomali: 1,
  khorasanrazavi: 30,
  khorasanjunubi: 78,
  khuzestan: 55,
  kvab: 7,
  kordestan: 43,
  lorestan: 45,
  markazi: 2,
  mazandaran: 33,
  ghazvin: 18,
  ghom: 29,
  semnan: 23,
  svab: 61,
  tehran: 56,
  yazd: 17,
  zanjan: 77,
  khazar: 54,
  khalijefars: 41,
  khark: 61,
  kish: 34,
  hormoz: 48,
  gheshm: 58,
  lark: 4,
  lavan: 55,
  faror: 23,
  hendorabi: 21,
  hengam: 4,
  siri: 2,
  abumusa: 34,
  tonbebozorg: 12,
  tonbekuchak: 53
}

export default testData
